import React, { useEffect } from 'react';
import type { ResponsePayload } from '../../../types';
import { AccordianQuestion } from '../../questions/Accordian';
import { registerQuestionRenderer, type QuestionRendererComponent } from './registry';

const AccordionRenderer: QuestionRendererComponent = ({
  question,
  existingResponse,
  onDraftChange,
  onHasUserInputChange,
  onValidityChange,
  onExtrasChange,
}) => {
  void onExtrasChange;
  const questionId = question?.id ?? existingResponse?.question ?? -1;

  useEffect(() => {
    if (questionId < 0) {
      onDraftChange(null);
    } else {
      const payload: ResponsePayload = {
        question: questionId,
      };
      onDraftChange(payload);
    }

    onHasUserInputChange?.(true);
    onValidityChange?.(true);
  }, [questionId, onDraftChange, onHasUserInputChange, onValidityChange]);

  return <AccordianQuestion options={question.options} />;
};

registerQuestionRenderer(['accordion'], AccordionRenderer);

